module.exports = __webpack_public_path__ + "img/144.10.6510358c.png";